
import { withRouter, WithRouter } from 'found';
import * as React from 'react';
import { connect } from 'react-redux';

import { BrowsePagePath } from '../../../../components/pages/browse/Browse';
import { QueryStringContext } from '../../../../contexts/queryString';
import { generateQueryStringFromState, getQueryStringStateForRoute } from '../../../../contexts/queryString/helpers';
import { IQueryStringState } from '../../../../contexts/queryString/types';
import { ActionSource, ISimilaritySearchActionPayload, similaritySearch } from '../../../../redux/actions/analytics';
import { pause } from '../../../../redux/actions/player';
import { linkWithQueryString } from '../../../../utils/router';
import Button, { ButtonProps } from '../Button';
import LinkButton, { LinkButtonProps } from '../LinkButton';

interface IOwnProps extends Omit<LinkButtonProps, 'to'> {
  track: GQL.ITrackSearchResult;
  addToCurrentFilters?: boolean;
  actionSource: ActionSource;
}

interface IOwnDispatchProps {
  sendAnalyticsEvent(data: ISimilaritySearchActionPayload): void;
  pausePlayer(): void;
}

type FindSimilarButtonWithRouterProps = IOwnProps & WithRouter;

class FindSimilarButtonComponent extends React.Component<FindSimilarButtonWithRouterProps & IOwnDispatchProps, {}> {
  defaultButtonProps: Partial<ButtonProps> = {
    colorScheme: 'black-outline',
    variant: 'pill',
    size: 'xsmall',
  };

  sendAnalyticsEvent() {
    this.props.sendAnalyticsEvent({
      actionSource: this.props.actionSource,
      trackId: `${this.props.track.id}-${this.props.track.internal_id}`,
    });
  }

  render() {
    const {
      track, match, router, addToCurrentFilters,
      actionSource, sendAnalyticsEvent, pausePlayer, ...rest
    } = this.props;
    const buttonProps = {
      ...this.defaultButtonProps,
      ...rest,
      title: 'Find similar tracks based on a deep learning analysis of the audio.',
      label: <span>Find&nbsp;Similar</span>,
    };

    if (addToCurrentFilters) {
      return (
        <QueryStringContext.Consumer>
          {(ctx) => (
            <Button
              onClick={(e: React.MouseEvent<any>) => {
                e.stopPropagation();
                this.sendAnalyticsEvent();
                ctx.addSimilarityFilter(this.props.track.id);
              }}
              {...buttonProps}
            />
          )}
        </QueryStringContext.Consumer>
      );

    }

    const qsState = getQueryStringStateForRoute(match);
    const linkQsState: IQueryStringState = {
      ...(qsState.license_params ? { license_params: qsState.license_params } : {}),
      filters: {
        similarity: {
          track_id: track.id,
          feature: GQL.TrackSimilarityFeature.Default,
        },
      },
    };

    const linkQs = generateQueryStringFromState(linkQsState);
    const to = linkWithQueryString(BrowsePagePath, linkQs);

    return (
      <LinkButton
        to={to}
        {...buttonProps}
        onClick={(e: React.MouseEvent<any>) => {
          e.stopPropagation();
          pausePlayer();
          this.sendAnalyticsEvent();
        }}
        includeQsParams={false}
        external
      />
    );
  }
}

// tslint:disable-next-line:max-line-length
const ConnectedFindSimilarButton = connect<FindSimilarButtonWithRouterProps, IOwnDispatchProps, FindSimilarButtonWithRouterProps>(
  null,
  (dispatch) => ({
    pausePlayer: () => dispatch(pause()),
    sendAnalyticsEvent(data) {
        return dispatch(similaritySearch(data));
    },
  }),
)(FindSimilarButtonComponent);

export const FindSimilarButton = withRouter<IOwnProps>(ConnectedFindSimilarButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/FindSimilarButton/index.tsx